export function Footer() {
  return (
    <footer id="footer" className="bg-neutral-cream py-6">
      <div id="footer-bottom" className="container mx-auto px-4">
        <nav>
          <ul id="bottom-menu" className="flex justify-center gap-8 mb-4">
            <li>
              <a 
                href="/menu/" 
                className="text-neutral-light hover:text-primary font-sans text-sm font-medium tracking-wide"
              >
                MENU
              </a>
            </li>
            <li>
              <a 
                href="/location/" 
                className="text-neutral-light hover:text-primary font-sans text-sm font-medium tracking-wide"
              >
                LOCATION
              </a>
            </li>
          </ul>
        </nav>
        
        <div className="text-center">
          <p id="copyright" className="text-neutral-light text-xs font-sans">
            © {new Date().getFullYear()} Dang's Vietnamese Restaurant | Designed by{' '}
            <a 
              href="http://www.elegantthemes.com" 
              title="Premium WordPress Themes"
              className="hover:text-primary"
            >
              Elegant Themes
            </a>
            {' | '}
            Powered by{' '}
            <a 
              href="http://www.wordpress.org"
              className="hover:text-primary"
            >
              WordPress
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}